var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .bch-cls-1 {\n                fill: #fff;\n            }\n\n            .bch-cls-2 {\n                fill: #000;\n            }\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12-bitcoin-cash-square-crop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "bch-cls-1",
    cx: 394,
    cy: 394,
    r: 335
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btc-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: "scale(0.051)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bch-cls-1",
    d: "M286.969.184 H-.539 V289.7 C36.53,149.1,146.755,38.2,286.969.184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bch-cls-1",
    d: "M788.539,289.7V.184H501.031C641.244,38.2,751.47,149.1,788.539,289.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bch-cls-1",
    d: "M501.031,787.816H788.539V498.3C751.47,638.9,641.244,749.8,501.031,787.816Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bch-cls-1",
    d: "M-.539,498.3V787.816H286.969C146.755,749.8,36.53,638.9-.539,498.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: " translate(-5.0, 20.0) rotate(-45) scale(0.89) translate(-726.000000, -282.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746,322 C734.954305,322 726,313.045695 726,302 C726,290.954305 734.954305,282 746,282 C757.045695,282 766,290.954305 766,302 C766,313.045695 757.045695,322 746,322 Z M754.889463,300.982887 C755.543168,298.462678 753.738166,296.878488 751.172775,295.676479 L752.402608,292.297538 L750.357788,291.553285 L749.159722,294.844946 C748.619424,294.648294 748.066657,294.447103 747.489703,294.260643 L748.699871,290.935732 L746.646739,290.188453 L745.412368,293.579862 C744.967661,293.418002 744.52711,293.257655 744.103184,293.103358 L741.260386,292.068664 L740.460162,294.267261 C740.460162,294.267261 741.991898,294.79182 741.956372,294.811837 C742.556893,294.949249 742.937359,295.541561 742.812613,296.144841 L739.440781,305.408872 C739.35877,305.597634 739.204957,305.745961 739.013343,305.821067 C738.821728,305.896172 738.608092,305.891871 738.419655,305.809115 C738.435516,305.843128 736.923445,305.264539 736.923445,305.264539 L735.588883,307.560469 L738.265436,308.534655 L739.736709,309.070154 L738.481159,312.519749 L740.56754,313.279129 L741.804937,309.879408 C742.359089,310.081103 742.913241,310.282798 743.467392,310.484493 L742.229995,313.884213 L744.308064,314.640569 L745.55605,311.211755 C749.08921,312.276504 751.825752,312.284113 753.310577,309.148597 C754.507284,306.623636 753.702139,305.007999 751.908734,303.818687 C753.322402,303.646039 754.454735,302.862668 754.935181,300.999527 L754.889463,300.982887 Z M749.352558,307.246738 C748.422241,309.802762 744.153231,307.914792 742.760924,307.408034 L744.409779,302.877844 C745.796416,303.387246 750.31918,304.590966 749.352558,307.246738 Z M750.720552,300.501005 C749.874947,302.824286 746.324184,301.225978 745.160465,300.802419 L746.655023,296.696155 C747.818742,297.119714 751.600949,298.082133 750.720552,300.501005 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBch);
export default __webpack_public_path__ + "static/media/bch.d975c832.svg";
export { ForwardRef as ReactComponent };